import React from "react";

import PMIDescriptionBody from "./body/body";
import PMIDescriptionTitle from "./title/title";

function PMIDescriptionSection() {
  return (
    <div className="flex flex-col-reverse md:flex-col h-full">
      <div className="flex-1 flex items-center justify-center">
        <section className="px-spacing-m md:px-spacing-xxxl">
          <div className=" lg:max-w-[325px] md:max-w-[432px] mx-auto">
            <PMIDescriptionTitle />
            <PMIDescriptionBody />
          </div>
        </section>
      </div>
    </div>
  );
}

export default PMIDescriptionSection;
